import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { type FC } from 'react'
import notificationCallQueuePath from 'sounds/notification_call_queue.mp3'
import { Box, Button, Dropdown, Icon } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { getCDNAssetURL } from 'shared/lib'
import { type IDeviceSettingsContentProps } from 'entities/DeviceSettings'
import styles from './styles.module.scss'

export const AudioOutputContent: FC<IDeviceSettingsContentProps> = observer(
  ({ deviceSettingsStore, parentsDropdownId, testOutputDevice, dropdownProps = {} }) => {
    const { audioOutputsItems, device, setSelectedAudioOutput } = deviceSettingsStore

    return (
      <div className={classnames(styles.section, styles['section--listen'])}>
        <div className={styles.box}>
          <div className={styles.title}>
            <div className={styles.icon}>
              <Icon icon={'volumeMax'} fontSize={18} />
            </div>
            <div className={styles.label}>Speaker</div>
          </div>

          <div
            className={styles.value}
            onClick={() => {
              if (testOutputDevice) {
                testOutputDevice()
              } else {
                const audio = new Audio(getCDNAssetURL(notificationCallQueuePath))
                audio.play()
              }
            }}
          >
            <Button text={'Test sound'} typeBtn={'text'} size={'small'} />
          </div>
        </div>

        <div className={styles.dropdownWrap}>
          <Box width={'100%'}>
            <Dropdown
              zIndex={ZIndex.OVERLAY_TOP_1}
              placement={'bottom-start'}
              items={audioOutputsItems}
              triggerComponent={() => (
                <div className={styles.dropdownBtn}>
                  <div className={styles.dropdownBtnLabel}>{device.audioOutput?.label}</div>
                  <div className={styles.dropdownBtnIcon}>
                    <Icon icon={'chevronDown'} color={'var(--content-primary-tertiary)'} />
                  </div>
                </div>
              )}
              width={232}
              margin={-20}
              onChange={(item) => {
                setSelectedAudioOutput(String(item.id))
              }}
              parentsDropdownId={parentsDropdownId}
              {...dropdownProps}
              ariaLabel={'AudioOutputContent'}
            />
          </Box>
        </div>
      </div>
    )
  }
)
